"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentEnvBaseApi = exports.getCurrentDomainName = void 0;
var constant_1 = require("./constant");
var getCurrentDomainName = function () {
    var hostname = window.location.hostname;
    if (hostname === 'localhost') {
        return 'dev.rentspree.dev';
    }
    var _a = hostname.split('.'), domain = _a.slice(1);
    return domain.join('.');
};
exports.getCurrentDomainName = getCurrentDomainName;
var getCurrentEnvBaseApi = function (_a) {
    var _b = _a.subdomainApi, subdomainApi = _b === void 0 ? 'www' : _b, _c = _a.prefixUri, prefixUri = _c === void 0 ? '' : _c;
    var domainName = (0, exports.getCurrentDomainName)();
    if (constant_1.AVAILABLE_DOMAIN.includes(domainName)) {
        return "https://".concat([subdomainApi, domainName].join('.')).concat(prefixUri);
    }
    return '';
};
exports.getCurrentEnvBaseApi = getCurrentEnvBaseApi;
//# sourceMappingURL=get-current-env-base-api.js.map